import { Box, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { Projeto } from "../../types";
import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR, MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA, MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO } from "src/App";
import { notifierStore } from "src/framework/store/NotifierStore";

interface ModalFinalizarParms {
    open: boolean;
    setOpenModal: Function;
    projeto?: Projeto;
    onSuccess: ()=>void;
}

const ModalFinalizar: FC<ModalFinalizarParms> = (modalFinalizarParams) => {
    const [projetoState, setProjetoState] = useState<Projeto>();
    
    const handleClose = () => {
        modalFinalizarParams.setOpenModal(false);
    };
    
    useEffect(() => {
        if (modalFinalizarParams.open && modalFinalizarParams?.projeto) {
            setProjetoState(modalFinalizarParams.projeto);
        }
    }, [modalFinalizarParams.open]);

    const doSave = async (): Promise<void> => {
        const data = { "projetos": [projetoState?.id] };
        const request: IDataRequest = {
            url: `/projetos/finalizar`,
            data: data
        }
        const response: IDataResponse = await api.post(request);
        if (response.statusCode === STATUS_CODE.OK) {
            if (projetoState) {
                projetoState.situacao = 'finalizado';
            }
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: ["Projeto finalizado com sucesso!"],
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false);
                    modalFinalizarParams.onSuccess();
                    modalFinalizarParams.setOpenModal(false);
                }
            });
            notifierStore.setOpen(true);
        } else {
            const content:string[] = [];
            content.push('Não foi possível finalizar o projeto.')
            if (response?.message) {
                if (Array.isArray(response?.message)) {
                    response?.message.forEach((m:string) => content.push(m));
                } else if (typeof response?.message === "string") {
                    content.push(response?.message);
                }
            }

            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: content,
                timeOut: 3500,
                onClose: () => {
                    const mensagemVigencia = content?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO) || content?.some((message:any) => message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO));
                    const mensagemSegmentoRevenda = content?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA) || content?.some((message:any) => message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA));
                    const mensagemSegmentoDistribuidor = content?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR) || content?.some((message:any) => message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR));
                    if (mensagemVigencia || mensagemSegmentoRevenda || mensagemSegmentoDistribuidor) window.location.href = `${window.location.origin}/projetos/menu-projetos`;
                    notifierStore.setOpen(false);
                }
            });
            notifierStore.setOpen(true);
        }
    }

    return (
        <Dialog
            open={modalFinalizarParams.open}
            onClose={handleClose}
            maxWidth='md'
        >
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Box component={"h2"}>Atenção!</Box>
                            <Box component={"span"}>Finalização do projeto - {projetoState?.codigo_venda}</Box>
                            <Box component={"p"}>Ao clicar em confirmar, você estará assumindo que a instalação <br/> foi concluída. Essa ação não poderá ser desfeita.</Box>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <FlatButton
                    color="inherit"
                    variant="contained"
                    disableElevation
                    text="Cancelar"
                    onClick={handleClose}
                />
                <FlatButton
                    color="primary"
                    variant="contained"
                    disableElevation
                    text="Confirmar"
                    onClick={doSave}
                />
            </DialogActions>
        </Dialog>
    )
}

export { ModalFinalizar }
